import { AutogenModelPnnSchedule, AutogenRowPnnSchedule } from "./autogen/AutogenModelPnnSchedule";

export class ModelPnnSchedule extends AutogenModelPnnSchedule<RowPnnSchedule> {
	constructor() {
		super(RowPnnSchedule);
	}
}

export class RowPnnSchedule extends AutogenRowPnnSchedule {
}